import styled from "styled-components";

type InputGroupProps = {
    spacing?: number
    center?: boolean
    flex?: boolean
}

const InputGroup = styled.div<InputGroupProps>`
    display: flex;
    justify-content: ${ props => props.center ? "center" : "start" };
    >* {
        flex: ${props => props.flex ? '1 1 0' : 'Initial'};
        margin: ${props => props.theme.spacing(0, props.spacing ? props.spacing/2 : 2)};
        overflow: hidden;
    }
    >*:first-child {
        margin-left: 0;
    }
    >*:last-child {
        margin-right: 0;
    }
`;

export default InputGroup;
export { InputGroup };